import { urlPrefixEN, urlPrefixES, urlPrefixPT } from '~/config/i18n.pages'

export default {
  data() {
    return {
      basePath: {
        'pt-br': `${urlPrefixPT}`,
        en: `${urlPrefixEN}`,
        es: `${urlPrefixES}`,
      },
      description: this.position.description
        .replaceAll('&lt;', '<')
        .replaceAll('&gt;', '>')
        .replaceAll('&amp;nbsp;', ' ')
        .replaceAll('&quot;', ''),
    }
  },

  props: {
    position: {
      type: Object,
      required: true,
    },
  },

  computed: {
    subtitle() {
      if (this.position._embedded) {
        const apiOffice =
          this.position._embedded.office[this.$i18n.locale.split(0, 2)]

        if (!apiOffice) {
          return ''
        }

        return `${apiOffice.country} - ${apiOffice.city}`
      }

      if (this.position.location) {
        return this.position.location.name
      }

      return ''
    },
  },

  methods: {
    goToProvider() {
      window.open(this.position.externalLink, '_blank')
    },
  },
}
